module.exports = __webpack_public_path__ + "static/img/g8.3dd2af4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/g8.svg
// module id = UFtt
// module chunks = 0